import type { ContributionSummaryState } from './types';

export const initialState: ContributionSummaryState = {
  data: {},
  orderedRecipientIds: [],
  isLoading: false,
  error: null,
};
